module.exports = __webpack_public_path__ + "assets/59e76101.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nature1.jpg
// module id = 99
// module chunks = 0